import { Integration, IntegrationCategory, IntegrationStatus } from '../../types';

export const mockIntegrations: Integration[] = [
  // CRM
  {
    id: 'affinity',
    name: 'Affinity',
    category: IntegrationCategory.CRM,
    description: 'Relationship intelligence platform for deal sourcing and management',
    logoUrl: '/logos/affinity.png',
    isConnected: true,
    connectedAt: '2024-01-15T10:30:00Z',
    lastSync: '2024-08-20T06:00:00Z',
    status: IntegrationStatus.Connected,
    settings: {
      syncFrequency: 'daily',
      enabledFeatures: ['contacts', 'deals', 'activities']
    }
  },
  {
    id: 'dealcloud',
    name: 'DealCloud',
    category: IntegrationCategory.CRM,
    description: 'Investment management CRM and deal sourcing platform',
    logoUrl: '/logos/dealcloud.png',
    isConnected: false,
    status: IntegrationStatus.Disconnected
  },
  {
    id: 'salesforce',
    name: 'SalesForce',
    category: IntegrationCategory.CRM,
    description: 'World\'s leading CRM platform',
    logoUrl: '/logos/salesforce.png',
    isConnected: true,
    connectedAt: '2024-02-01T14:20:00Z',
    lastSync: '2024-08-20T05:30:00Z',
    status: IntegrationStatus.Connected,
    settings: {
      syncFrequency: 'hourly',
      enabledFeatures: ['leads', 'opportunities', 'accounts', 'contacts']
    }
  },
  {
    id: 'hubspot',
    name: 'HubSpot',
    category: IntegrationCategory.CRM,
    description: 'Inbound marketing and sales platform',
    logoUrl: '/logos/hubspot.png',
    isConnected: false,
    status: IntegrationStatus.Disconnected
  },

  // RMS
  {
    id: 'bipsync',
    name: 'Bipsync',
    category: IntegrationCategory.RMS,
    description: 'Research management system for investment professionals',
    logoUrl: '/logos/bipsync.png',
    isConnected: true,
    connectedAt: '2024-03-10T09:15:00Z',
    lastSync: '2024-08-20T04:45:00Z',
    status: IntegrationStatus.Connected
  },
  {
    id: 'verity',
    name: 'Verity',
    category: IntegrationCategory.RMS,
    description: 'Research management and compliance platform',
    logoUrl: '/logos/verity.png',
    isConnected: false,
    status: IntegrationStatus.Disconnected
  },

  // Document Repository
  {
    id: 'box',
    name: 'Box',
    category: IntegrationCategory.DocumentRepository,
    description: 'Cloud content management and file sharing service',
    logoUrl: '/logos/box.png',
    isConnected: true,
    connectedAt: '2024-01-20T11:00:00Z',
    lastSync: '2024-08-20T06:15:00Z',
    status: IntegrationStatus.Connected,
    settings: {
      syncFrequency: 'real-time',
      enabledFeatures: ['file_sync', 'folder_structure', 'permissions']
    }
  },
  {
    id: 'dropbox',
    name: 'DropBox',
    category: IntegrationCategory.DocumentRepository,
    description: 'Cloud storage and file synchronization service',
    logoUrl: '/logos/dropbox.png',
    isConnected: false,
    status: IntegrationStatus.Disconnected
  },
  {
    id: 'egnyte',
    name: 'Egnyte',
    category: IntegrationCategory.DocumentRepository,
    description: 'Enterprise file sharing and content governance platform',
    logoUrl: '/logos/egnyte.png',
    isConnected: true,
    connectedAt: '2024-02-15T13:30:00Z',
    lastSync: '2024-08-20T05:00:00Z',
    status: IntegrationStatus.Connected
  },
  {
    id: 'office365',
    name: 'Office 365',
    category: IntegrationCategory.DocumentRepository,
    description: 'Microsoft\'s cloud-based productivity suite',
    logoUrl: '/logos/office365.png',
    isConnected: true,
    connectedAt: '2024-01-10T08:00:00Z',
    lastSync: '2024-08-20T06:30:00Z',
    status: IntegrationStatus.Connected,
    settings: {
      syncFrequency: 'real-time',
      enabledFeatures: ['sharepoint', 'onedrive', 'teams_files']
    }
  },
  {
    id: 'sharepoint',
    name: 'Sharepoint',
    category: IntegrationCategory.DocumentRepository,
    description: 'Microsoft\'s web-based collaborative platform',
    logoUrl: '/logos/sharepoint.png',
    isConnected: true,
    connectedAt: '2024-01-10T08:00:00Z',
    lastSync: '2024-08-20T06:30:00Z',
    status: IntegrationStatus.Connected
  },
  {
    id: 'googledrive',
    name: 'Google Drive',
    category: IntegrationCategory.DocumentRepository,
    description: 'Google\'s cloud storage and file sharing service',
    logoUrl: '/logos/googledrive.png',
    isConnected: false,
    status: IntegrationStatus.Disconnected
  },
  {
    id: 'diligencevault',
    name: 'DiligenceVault',
    category: IntegrationCategory.DocumentRepository,
    description: 'Secure document sharing for due diligence processes',
    logoUrl: '/logos/diligencevault.png',
    isConnected: false,
    status: IntegrationStatus.Disconnected
  },
  {
    id: 'intralink',
    name: 'Intralink',
    category: IntegrationCategory.DocumentRepository,
    description: 'Document management and workflow platform',
    logoUrl: '/logos/intralink.png',
    isConnected: false,
    status: IntegrationStatus.Disconnected
  },

  // Portfolio Management
  {
    id: 'cobalt',
    name: 'Cobalt',
    category: IntegrationCategory.PortfolioManagement,
    description: 'Portfolio management and reporting platform',
    logoUrl: '/logos/cobalt.png',
    isConnected: true,
    connectedAt: '2024-03-01T10:00:00Z',
    lastSync: '2024-08-20T04:00:00Z',
    status: IntegrationStatus.Connected,
    settings: {
      syncFrequency: 'daily',
      enabledFeatures: ['portfolio_data', 'performance_metrics', 'reporting']
    }
  },
  {
    id: 'crunchbase',
    name: 'Crunchbase',
    category: IntegrationCategory.PortfolioManagement,
    description: 'Company and investment database',
    logoUrl: '/logos/crunchbase.png',
    isConnected: true,
    connectedAt: '2024-04-01T12:00:00Z',
    lastSync: '2024-08-20T03:30:00Z',
    status: IntegrationStatus.Connected
  },
  {
    id: 'lemonedge',
    name: 'Lemon Edge',
    category: IntegrationCategory.PortfolioManagement,
    description: 'Investment management and portfolio analytics platform',
    logoUrl: '/logos/lemonedge.png',
    isConnected: false,
    status: IntegrationStatus.Disconnected
  },
  {
    id: 'efront',
    name: 'eFront',
    category: IntegrationCategory.PortfolioManagement,
    description: 'Alternative investment management software',
    logoUrl: '/logos/efront.png',
    isConnected: false,
    status: IntegrationStatus.Disconnected
  },
  {
    id: 'ilevel',
    name: 'iLevel',
    category: IntegrationCategory.PortfolioManagement,
    description: 'Portfolio management and risk analytics platform',
    logoUrl: '/logos/ilevel.png',
    isConnected: false,
    status: IntegrationStatus.Disconnected
  },

  // Compliance
  {
    id: 'encorecompliance',
    name: 'Encore Compliance',
    category: IntegrationCategory.Compliance,
    description: 'Regulatory compliance and risk management platform',
    logoUrl: '/logos/encore.png',
    isConnected: true,
    connectedAt: '2024-02-20T15:00:00Z',
    lastSync: '2024-08-20T02:00:00Z',
    status: IntegrationStatus.Connected
  },
  {
    id: 'vanta',
    name: 'Vanta',
    category: IntegrationCategory.Compliance,
    description: 'Automated security and compliance platform',
    logoUrl: '/logos/vanta.png',
    isConnected: false,
    status: IntegrationStatus.Disconnected
  },
  {
    id: 'drata',
    name: 'Drata',
    category: IntegrationCategory.Compliance,
    description: 'Continuous compliance automation platform',
    logoUrl: '/logos/drata.png',
    isConnected: false,
    status: IntegrationStatus.Disconnected
  },

  // Market Intelligence
  {
    id: 'fmp',
    name: 'FMP',
    category: IntegrationCategory.MarketIntelligence,
    description: 'Financial market data and analytics platform',
    logoUrl: '/logos/fmp.png',
    isConnected: true,
    connectedAt: '2024-01-25T09:30:00Z',
    lastSync: '2024-08-20T06:45:00Z',
    status: IntegrationStatus.Connected,
    settings: {
      syncFrequency: 'hourly',
      enabledFeatures: ['market_data', 'company_financials', 'news']
    }
  },
  {
    id: 'grata',
    name: 'Grata',
    category: IntegrationCategory.MarketIntelligence,
    description: 'Private company intelligence and deal sourcing platform',
    logoUrl: '/logos/grata.png',
    isConnected: true,
    connectedAt: '2024-03-15T11:45:00Z',
    lastSync: '2024-08-20T05:15:00Z',
    status: IntegrationStatus.Connected
  },
  {
    id: 'pitchbook',
    name: 'PitchBook',
    category: IntegrationCategory.MarketIntelligence,
    description: 'Private capital market data and research platform',
    logoUrl: '/logos/pitchbook.png',
    isConnected: true,
    connectedAt: '2024-02-10T14:00:00Z',
    lastSync: '2024-08-20T04:30:00Z',
    status: IntegrationStatus.Connected,
    settings: {
      syncFrequency: 'daily',
      enabledFeatures: ['deal_data', 'company_profiles', 'market_research']
    }
  },
  {
    id: 'spcapitaliq',
    name: 'S&P Capital IQ',
    category: IntegrationCategory.MarketIntelligence,
    description: 'Financial market intelligence and analytics platform',
    logoUrl: '/logos/spcapitaliq.png',
    isConnected: false,
    status: IntegrationStatus.Disconnected
  },
  {
    id: 'alphasense',
    name: 'AlphaSense',
    category: IntegrationCategory.MarketIntelligence,
    description: 'AI-powered market intelligence and search platform',
    logoUrl: '/logos/alphasense.png',
    isConnected: false,
    status: IntegrationStatus.Disconnected
  },
  {
    id: 'bloomberg',
    name: 'Bloomberg',
    category: IntegrationCategory.MarketIntelligence,
    description: 'Financial data and analytics terminal',
    logoUrl: '/logos/bloomberg.png',
    isConnected: true,
    connectedAt: '2024-01-05T07:00:00Z',
    lastSync: '2024-08-20T06:50:00Z',
    status: IntegrationStatus.Connected,
    settings: {
      syncFrequency: 'real-time',
      enabledFeatures: ['market_data', 'news', 'analytics', 'research']
    }
  },
  {
    id: 'evestment',
    name: 'eVestment',
    category: IntegrationCategory.MarketIntelligence,
    description: 'Investment data and analytics platform',
    logoUrl: '/logos/evestment.png',
    isConnected: false,
    status: IntegrationStatus.Disconnected
  },
  {
    id: 'icapital',
    name: 'iCapital',
    category: IntegrationCategory.MarketIntelligence,
    description: 'Alternative investment platform and marketplace',
    logoUrl: '/logos/icapital.png',
    isConnected: false,
    status: IntegrationStatus.Disconnected
  },
  {
    id: 'preqin',
    name: 'Preqin',
    category: IntegrationCategory.MarketIntelligence,
    description: 'Alternative assets data and intelligence platform',
    logoUrl: '/logos/preqin.png',
    isConnected: false,
    status: IntegrationStatus.Disconnected
  },

  // Public Data Sources
  {
    id: 'google',
    name: 'Google',
    category: IntegrationCategory.PublicDataSources,
    description: 'Google APIs for search, maps, and public data',
    logoUrl: '/logos/google.png',
    isConnected: true,
    connectedAt: '2024-01-01T00:00:00Z',
    lastSync: '2024-08-20T07:00:00Z',
    status: IntegrationStatus.Connected,
    settings: {
      syncFrequency: 'real-time',
      enabledFeatures: ['search', 'maps', 'places', 'trends']
    }
  },
  {
    id: 'googlenews',
    name: 'Google News',
    category: IntegrationCategory.PublicDataSources,
    description: 'Google News API for news aggregation',
    logoUrl: '/logos/googlenews.png',
    isConnected: true,
    connectedAt: '2024-01-01T00:00:00Z',
    lastSync: '2024-08-20T07:00:00Z',
    status: IntegrationStatus.Connected
  },

  // Security
  {
    id: 'okta',
    name: 'Okta',
    category: IntegrationCategory.Security,
    description: 'Identity and access management platform',
    logoUrl: '/logos/okta.png',
    isConnected: true,
    connectedAt: '2024-01-01T00:00:00Z',
    lastSync: '2024-08-20T06:00:00Z',
    status: IntegrationStatus.Connected,
    settings: {
      syncFrequency: 'real-time',
      enabledFeatures: ['sso', 'user_provisioning', 'mfa']
    }
  },
  {
    id: 'onelogin',
    name: 'OneLogin',
    category: IntegrationCategory.Security,
    description: 'Identity and access management solution',
    logoUrl: '/logos/onelogin.png',
    isConnected: false,
    status: IntegrationStatus.Disconnected
  },
  {
    id: 'entraid',
    name: 'Entra Id',
    category: IntegrationCategory.Security,
    description: 'Microsoft\'s identity and access management service',
    logoUrl: '/logos/entraid.png',
    isConnected: true,
    connectedAt: '2024-01-10T08:00:00Z',
    lastSync: '2024-08-20T06:30:00Z',
    status: IntegrationStatus.Connected
  },
  {
    id: 'pingidentity',
    name: 'Ping Identity',
    category: IntegrationCategory.Security,
    description: 'Identity security platform',
    logoUrl: '/logos/pingidentity.png',
    isConnected: false,
    status: IntegrationStatus.Disconnected
  },
  {
    id: 'auth0',
    name: 'Auth0',
    category: IntegrationCategory.Security,
    description: 'Identity platform for developers',
    logoUrl: '/logos/auth0.png',
    isConnected: false,
    status: IntegrationStatus.Disconnected
  },

  // Collaboration
  {
    id: 'slack',
    name: 'Slack',
    category: IntegrationCategory.Collaboration,
    description: 'Business communication and collaboration platform',
    logoUrl: '/logos/slack.png',
    isConnected: true,
    connectedAt: '2024-01-15T10:00:00Z',
    lastSync: '2024-08-20T06:45:00Z',
    status: IntegrationStatus.Connected,
    settings: {
      syncFrequency: 'real-time',
      enabledFeatures: ['notifications', 'file_sharing', 'bot_integration']
    }
  },
  {
    id: 'teams',
    name: 'Teams',
    category: IntegrationCategory.Collaboration,
    description: 'Microsoft Teams collaboration platform',
    logoUrl: '/logos/teams.png',
    isConnected: true,
    connectedAt: '2024-01-10T08:00:00Z',
    lastSync: '2024-08-20T06:30:00Z',
    status: IntegrationStatus.Connected
  },
  {
    id: 'zoom',
    name: 'Zoom',
    category: IntegrationCategory.Collaboration,
    description: 'Video conferencing and communication platform',
    logoUrl: '/logos/zoom.png',
    isConnected: true,
    connectedAt: '2024-02-01T09:00:00Z',
    lastSync: '2024-08-20T05:00:00Z',
    status: IntegrationStatus.Connected
  },

  // Documentation
  {
    id: 'confluence',
    name: 'Confluence',
    category: IntegrationCategory.Documentation,
    description: 'Team collaboration and documentation platform',
    logoUrl: '/logos/confluence.png',
    isConnected: true,
    connectedAt: '2024-03-01T12:00:00Z',
    lastSync: '2024-08-20T04:00:00Z',
    status: IntegrationStatus.Connected
  },
  {
    id: 'notion',
    name: 'Notion',
    category: IntegrationCategory.Documentation,
    description: 'All-in-one workspace for notes, docs, and collaboration',
    logoUrl: '/logos/notion.png',
    isConnected: false,
    status: IntegrationStatus.Disconnected
  },

  // REIT
  {
    id: 'yardi',
    name: 'Yardi',
    category: IntegrationCategory.REIT,
    description: 'Real estate investment and property management software',
    logoUrl: '/logos/yardi.png',
    isConnected: true,
    connectedAt: '2024-04-01T10:00:00Z',
    lastSync: '2024-08-20T03:00:00Z',
    status: IntegrationStatus.Connected,
    settings: {
      syncFrequency: 'daily',
      enabledFeatures: ['property_data', 'financial_reporting', 'tenant_management']
    }
  },
  {
    id: 'appfolio',
    name: 'AppFolio',
    category: IntegrationCategory.REIT,
    description: 'Property management software platform',
    logoUrl: '/logos/appfolio.png',
    isConnected: false,
    status: IntegrationStatus.Disconnected
  },
  {
    id: 'mri',
    name: 'MRI',
    category: IntegrationCategory.REIT,
    description: 'Real estate software and technology solutions',
    logoUrl: '/logos/mri.png',
    isConnected: false,
    status: IntegrationStatus.Disconnected
  },
  {
    id: 'loopnet',
    name: 'LoopNet',
    category: IntegrationCategory.REIT,
    description: 'Commercial real estate marketplace and data platform',
    logoUrl: '/logos/loopnet.png',
    isConnected: true,
    connectedAt: '2024-05-01T11:00:00Z',
    lastSync: '2024-08-20T02:30:00Z',
    status: IntegrationStatus.Connected
  },

  // LLM
  {
    id: 'perplexity',
    name: 'Perplexity',
    category: IntegrationCategory.LLM,
    description: 'AI-powered search and answer engine',
    logoUrl: '/logos/perplexity.png',
    isConnected: true,
    connectedAt: '2024-06-01T14:00:00Z',
    lastSync: '2024-08-20T01:00:00Z',
    status: IntegrationStatus.Connected,
    settings: {
      syncFrequency: 'on-demand',
      enabledFeatures: ['search', 'summarization', 'qa']
    }
  },
  {
    id: 'openai',
    name: 'OpenAI',
    category: IntegrationCategory.LLM,
    description: 'GPT models and AI API services',
    logoUrl: '/logos/openai.png',
    isConnected: true,
    connectedAt: '2024-01-01T00:00:00Z',
    lastSync: '2024-08-20T07:00:00Z',
    status: IntegrationStatus.Connected,
    settings: {
      syncFrequency: 'real-time',
      enabledFeatures: ['chat_completion', 'embeddings', 'fine_tuning']
    }
  },
  {
    id: 'anthropic',
    name: 'Anthropic',
    category: IntegrationCategory.LLM,
    description: 'Claude AI models and API services',
    logoUrl: '/logos/anthropic.png',
    isConnected: true,
    connectedAt: '2024-03-01T10:00:00Z',
    lastSync: '2024-08-20T06:30:00Z',
    status: IntegrationStatus.Connected
  },
  {
    id: 'gemini',
    name: 'Gemini',
    category: IntegrationCategory.LLM,
    description: 'Google\'s AI model and API services',
    logoUrl: '/logos/gemini.png',
    isConnected: false,
    status: IntegrationStatus.Disconnected
  },
  {
    id: 'openanallm',
    name: 'OpenAna LLM',
    category: IntegrationCategory.LLM,
    description: 'OpenAna\'s proprietary language model',
    logoUrl: '/logos/openana.png',
    isConnected: true,
    connectedAt: '2024-01-01T00:00:00Z',
    lastSync: '2024-08-20T07:00:00Z',
    status: IntegrationStatus.Connected,
    settings: {
      syncFrequency: 'real-time',
      enabledFeatures: ['document_analysis', 'investment_insights', 'risk_assessment']
    }
  },

  // Public Clouds
  {
    id: 'aws',
    name: 'AWS',
    category: IntegrationCategory.PublicClouds,
    description: 'Amazon Web Services cloud platform',
    logoUrl: '/logos/aws.png',
    isConnected: true,
    connectedAt: '2024-01-01T00:00:00Z',
    lastSync: '2024-08-20T06:00:00Z',
    status: IntegrationStatus.Connected,
    settings: {
      syncFrequency: 'real-time',
      enabledFeatures: ['s3', 'ec2', 'rds', 'lambda']
    }
  },
  {
    id: 'azure',
    name: 'Azure',
    category: IntegrationCategory.PublicClouds,
    description: 'Microsoft Azure cloud platform',
    logoUrl: '/logos/azure.png',
    isConnected: true,
    connectedAt: '2024-01-10T08:00:00Z',
    lastSync: '2024-08-20T06:30:00Z',
    status: IntegrationStatus.Connected
  },
  {
    id: 'gcp',
    name: 'GCP',
    category: IntegrationCategory.PublicClouds,
    description: 'Google Cloud Platform',
    logoUrl: '/logos/gcp.png',
    isConnected: false,
    status: IntegrationStatus.Disconnected
  },

  // Productivity
  {
    id: 'jira',
    name: 'Jira',
    category: IntegrationCategory.Productivity,
    description: 'Project management and issue tracking platform',
    logoUrl: '/logos/jira.png',
    isConnected: true,
    connectedAt: '2024-02-15T13:00:00Z',
    lastSync: '2024-08-20T05:00:00Z',
    status: IntegrationStatus.Connected,
    settings: {
      syncFrequency: 'hourly',
      enabledFeatures: ['issues', 'projects', 'workflows']
    }
  }
];

// Helper functions
export const getIntegrationsByCategory = (category: IntegrationCategory): Integration[] => {
  return mockIntegrations.filter(integration => integration.category === category);
};

export const getConnectedIntegrations = (): Integration[] => {
  return mockIntegrations.filter(integration => integration.isConnected);
};

export const getIntegrationById = (id: string): Integration | undefined => {
  return mockIntegrations.find(integration => integration.id === id);
};

export const getIntegrationCategories = (): IntegrationCategory[] => {
  return Object.values(IntegrationCategory);
};

export const getIntegrationCountByCategory = (): Record<string, { total: number; connected: number }> => {
  const categories = getIntegrationCategories();
  const result: Record<string, { total: number; connected: number }> = {};
  
  categories.forEach(category => {
    const categoryIntegrations = getIntegrationsByCategory(category);
    result[category] = {
      total: categoryIntegrations.length,
      connected: categoryIntegrations.filter(i => i.isConnected).length
    };
  });
  
  return result;
};
